import styled, { css } from 'styled-components/macro'

import { Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const Label = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  color: ${getToken('color-neutral-darker')};
  font-size: 12px;
  text-transform: uppercase;
  font-weight: ${getToken('font-weight-bold')};

  & > svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`

export const Description = styled.div`
  font-size: 14px;

  margin-top: 4px;

  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  color: ${props =>
    props.highlight ? getToken('color-primary') : getToken('color-neutral-darkest')};

  ${({ rightAligned }) =>
    rightAligned
      ? `
        margin-left: auto;
    `
      : ''};
`

const inlineSectionStyle = css`
  display: flex;
  align-items: center;

  ${Label} {
    margin-right: 8px;
    margin-bottom: 0;
  }

  ${Description} {
    margin-top: 0;
  }

  & + & {
    margin-top: 6px;
  }
`

export const Section = styled.section`
  & + & {
    margin-top: 16px;
  }

  ${({ inline }) => (inline ? inlineSectionStyle : '')};
`
export const UppercaseHeading = styled(Text)`
  text-transform: uppercase;
`

export const LeftMarginBox = styled.div`
  margin-left: 7.25rem;
`
